import React from "react";

/**
 * "Compare with" range switch (Previous cycle / 3 months / 6 months / 1 year).
 * Rendered only when the ranges would give different results (`tf.show`).
 *
 * @param {Object} props
 * @param {{ show: boolean, opts: Array<{key: string, label: string, active: boolean}>, note: string, sectionId: string }} props.tf
 * @param {(sectionId: string, rangeKey: string) => void} props.onPick
 */
const CompareWith = ({ tf, onPick }) => {
  if (!tf?.show) return null;
  return (
    <div className="flex items-center gap-[10px] flex-wrap">
      <span className="text-[11px] font-semibold text-[#6b6b6b]">Compare with</span>
      <div
        role="group"
        aria-label="Compare with"
        className="flex flex-wrap gap-[2px] p-[2px] bg-white border border-[#E8E0D9] rounded-[8px]"
      >
        {tf.opts.map((o) => (
          <button
            key={o.key}
            type="button"
            aria-pressed={o.active}
            onClick={() => onPick(tf.sectionId, o.key)}
            className={`px-[10px] py-[4px] rounded-[6px] text-[11px] whitespace-nowrap transition-colors duration-200 ${
              o.active ? "bg-[#1f1f1f] text-white font-bold" : "text-[#555] font-semibold hover:bg-[#F6F2EF]"
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>
      <span className="text-[11px] text-[#8a8a8a]">{tf.note}</span>
    </div>
  );
};

export default CompareWith;
